import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { LoyaltyProgram } from '../entities/loyalty-program';



export class LoyaltyProgramRequest extends BaseRequest {

  loyaltyProgram : LoyaltyProgram;

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.loyaltyProgram = new LoyaltyProgram()
  }
}